import jwt from '../../http/requests/auth/jwt';
import axios from '@/axios';
import {
  DEFAULT_PAYMENT_ERROR_MESSAGE,
  PAYMENT_FAILED_TITLE,
} from '@/constants/paymentErrors';

export default {
  fetchFilterData(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchProductFilter(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchProductDetail(_context, id) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchEcommerceProductDetail(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  productFilterListing(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchProductListing(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  toggleItemInWishList({commit}, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST', item);
  },
  setCategoryData({commit}, data) {
    commit('SET_CATEGORY_DATA', data);
  },

  toggleItemInCart({ getters, dispatch }, item) {
    if (getters.isInCart(item._id)) {
      return dispatch('removeItemFromCart', item);
    } else {
      dispatch('additemInCart', item);
    }
  },

  removeItemFromCart({commit}, item) {
    return new Promise((resolve, reject) => {
      jwt
        .removeProductStore(item.productStoreId)
        .then(res => {
          commit('REMOVE_ITEM_FROM_CART', item);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  removeInactiveItemFromCart({commit}, item) {
    return new Promise((resolve, reject) => {
      jwt
        .removeProductStore(item.productStoreId)
        .then(res => {
          commit('REMOVE_INACTIVE_ITEM_FROM_CART', item);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  additemInCart({commit}, item) {
    
    const product = item.data;
    const minQty = item.minQty > 1 ? item.minQty : 1;

    product['availableQuantity'] = item.data.quantity;
    product['selectedQuantity'] = item.type === 'decrement' ? -1 : minQty;

    return new Promise((resolve, reject) => {
      jwt
        .addProductStoreInCart(product)
        .then(res => {
          commit('ADD_ITEM_IN_CART', res.data.data);
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  insertFailedOrders(_context, data) {
    return  jwt.insertFailedOrdersToCart(data);
  },
  additemInCartHomepage({commit}, item) {
    
    const product = item.data;
    const minQty = item.minQty > 1 ? item.minQty : 1;

    product['availableQuantity'] = item.data.quantity;
    product['selectedQuantity'] = item.type === 'decrement' ? -1 : minQty;
    
    return new Promise((resolve, reject) => {
      jwt
        .addProductStoreInCart(product)
        .then(res => {
          commit('ADD_ITEM_IN_CART', res.data.data);
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getCartItemsFromApi({commit}, id = null) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchCartItems(id) 
        .then(res => {
          commit('API_CART_ITEMS', {items: res.data.data, clinicId: sessionStorage.getItem('doctorClinicSelectedClinic'),
          });
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateItemQuantity({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .updateProductStoreCartFromCheckout(payload.item)
        .then(({ data }) => {
          commit('UPDATE_ITEM_QUANTITY', { data: data.data });
          return resolve(data);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  retryPayment(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .retryPayment(payload)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          console.error(err);
          return reject(err);
        });
    });
  },
  paymentForCartItems({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .paymentForCart(payload)
        .then(res => {
          if (res.data.data.requires_action) {
            return resolve({...res.data.data});
          }
          // Defensive only: the checkoutPayment API reports payment failures
          // as HTTP 500 via respondError, which the axios interceptor already
          // rejects as error.data = { title, message }. A 200 with a truthy
          // `error` is not expected from this endpoint, but if one ever
          // arrives, reject in that same shape instead of resolving it as a
          // successful payment. The title is fixed because a 200's title is
          // the success title (e.g. 'Order'), not an error title.
          if (res.data.data.error) {
            const paymentError = res.data.data.error;
            return reject({
              data: {
                title: PAYMENT_FAILED_TITLE,
                message:
                  (typeof paymentError === 'string' ? paymentError : paymentError.message) ||
                  res.data.message ||
                  DEFAULT_PAYMENT_ERROR_MESSAGE,
              },
            });
          }
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.user.firstName
          );

          commit('UPDATE_USER_INFO', res.data.data.user, { root: true });
          return resolve(res);
        })
        .catch(err => {
          console.error(err);
          return reject(err);
        });
    });
  },
  fetchOrderedList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchOrderedProductList(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchFailedPayments() {
    return new Promise((resolve, reject) => {
      jwt
        .hasFailedPayments(sessionStorage.getItem('doctorClinicSelectedClinic'))
        .then(res => {
          resolve(res.data.data);
        })
        .catch(() => {
          reject(false);
        });
    });
  },
  fetchOrderDetail(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchOrderDetailApi(data.orderId, data.clinicId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateOrderDetail(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .updateOrderStatusApi(data.orderId, { status: data.status })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  orderPayment(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .orderPaymentApi(data.orderId, { status: data.status })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  sendEnquiry(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .sendEnquiry(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMinimumOrderSuppliers() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchSupplierMinimumOrder()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getRequirementMinimumOrder() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchMinimumOrderRequirement()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getCardSurchargeStatus() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchCardSurchargeStatus()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getPaymentEfficiencyBenefitStatus(_context, clinicId) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchPaymentEfficiencyBenefitStatus(clinicId)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createMinimumOrder(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .createMinimumOrder(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateSearchText({commit}, text){
    commit('UPDATE_SEARCH_TEXT', text); 
  },
  resetSearchText({commit}){
    commit('UPDATE_SEARCH_TEXT', ''); 
  },
  algoliaSync() {
    return axios
      .get('/api/v1/webhooks/algolia/sync')
      .then(res => {
        return Promise.resolve(res);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  },
  async getHomepageProductsByIds(_context, data) {
    try {
      const response = await axios.get('/api/v1/store/homepageTemplate/product/list', { params: { ids: data.ids, clinicId: data.clinicId, isPreviewPage: data.isPreviewPage } } );
      return response;
    } catch (error) {
      throw error;
    }
  },
  async getJsonSettings(_context, data) {
    const { slug } = data;
    try {
      const response = await axios.get('/api/v1/store/jsonSettings', { params: { slug } } );
      return response;
    } catch (error) {
      throw error;
    }
  },
  async saveJsonSettings(_context, data) {
    const { value, slug } = data;
    try {
      const response = await axios.post('/api/v1/store/jsonSettings/save', { value },{params: {slug}} );
      return response;
    } catch (error) {
      throw error;
    }
  },
  fetchProductByCategory(_context, slug) {
    return axios.get('api/v1/store/products/byCategory?slug=' + slug);
  },
  orderAgain(_context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/inventory/order-again', data)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async getProductOrderByCategory(_context, data) {
    try {
      const response = await axios.get('/api/v1/store/products/ordersByCategory?categoryId=' + data );
      return response;
    } catch (error) {
      throw error;
    }
  },
  async saveFeedback(_context, data) {
    try {
      const response = await axios.post('/api/v1/store/feedbackSurvey/save', data );
      return response;
    } catch (error) {
      throw error;
    }
  },
  uploadMedia(_context, data) {
    let path = '/api/v1/store/jsonSettings/uploadMedia';
    return new Promise((resolve, reject) => {
      let config = {
        header: {
          'Content-Type': 'multipart/form-data',
        },
      };
      axios
        .post(path, data, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async getBrandJsonSettings(_context, data) {
    const { brandId } = data;
    try {
      const response = await axios.get('/api/v1/store/brandJsonSettings', { params: { brandId } } );
      return response;
    } catch (error) {
      throw error;
    }
  },
  async saveBrandJsonSettings(_context, data) {
    const { value, brandId } = data;
    try {
      const response = await axios.post('/api/v1/store/brandJsonSettings/save', { value },{ params: { brandId }} );
      return response;
    } catch (error) {
      throw error;
    }
  },
  validateTCProducts(_context, data) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/store/products/validateTCProducts/${data.orderId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchOrderRequestList(_context, data) {
    let payload = Object.assign({}, data);
    const clinic = sessionStorage.getItem('doctorClinicSelectedClinic');

    if (!data.clinicId) payload.clinicId = clinic;

    return axios.get('/api/v1/clinics/orders-request', { params: payload } );
  },
};
